import { Route, Routes } from "react-router-dom";
import { ESGApp } from "./App";

import { withAuthenticationRequired } from "@auth0/auth0-react";
import { AppSpinner } from "./components/AppSpinner";
import { publicPages } from "./config";
import { UserInvitation } from "./pages/UserInvitation";

const ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <AppSpinner isDefaultShown={true} />,
  });
  return <Component />;
};

function MainApp() {
  return (
    <Routes>
      <Route path="/*" element={<ProtectedRoute component={ESGApp} />} />
      <Route path="/login" element={<UserInvitation />} />

      {publicPages.map((page) => {
        return <Route key={page.path} path={page.path} element={page.element} />;
      })}
    </Routes>
  );
}

export default MainApp;
